import React from 'react';
import InputField, {InputFieldProps} from "./InputField";

// Component ----

export type TextFieldProps = Omit<InputFieldProps, 'type'>

function TextField(props: TextFieldProps) {
    return <InputField type="text" {...props} />
}

export default TextField;